import { getPathFromUrl } from "./pageUtils.js";
import { findParentKey } from "./miscUtils.js";

import * as Constants from "../../config/constants/Constants.js";

/**
 * Return the category of the current page.
 */
export const getCategory = (allowSubcategories = true) => {
    const path = getPathFromUrl();
    const category = getCategoryByPath(path, allowSubcategories);

    return category;
};

/**
 * Return any subcategories of the current page.
 */
export const getSubcategories = () => {
    const path = getPathFromUrl();
    const category = getCategoryByPath(path, false);
    const subcategories = getSubcategoriesByCategory(category);

    return subcategories;
};

/**
 * Find and return the (sub)category according to the 'path' value.
 */
export const getSubcategoriesByCategory = (category) => {
    if (category?.subcategories && Object.keys(category.subcategories).length > 0) {
        return Object.entries(category.subcategories);
    }

    return null;
};

/**
 * Find and return the (sub)category according to the 'path' value.
 */
export const getCategoryByPath = (path, allowSubcategories = true, customCategoryArray = null) => {
    const array = customCategoryArray ?? Constants.DROPDOWN_CATEGORIES;

    for (const mainCategories of array) {
        if (path.startsWith(mainCategories.path)) {
            for (const category of Object.values(mainCategories.categories)) {
                if (path.startsWith(mainCategories.path + category.path) && !allowSubcategories) return category;
                if (path.endsWith(category.path)) return category;

                // Check if it's a subcategory.
                if (category.subcategories && Object.keys(category.subcategories).length > 0) {
                    for (const subcategory of Object.values(category.subcategories)) {
                        if (path.endsWith(subcategory.path)) return subcategory;
                    }
                }
            }
        }
    }

    return null;
};

/**
 * Return the key-value pair's parent object.
 * Loop though all the categories constants.
 */
export const findCategoryParent = (targetKey, customCategoryArray = null) => {
    const array = customCategoryArray ?? Constants.DROPDOWN_CATEGORIES;

    for (const obj of array) {
        const key = findParentKey(obj, targetKey);

        if (key) return obj;
    }

    return null;
};
